<template>
  <div class="collapse navbar-collapse stroke show" id="navbarNav">
    <ul id="HeaderUL" class="navbar-nav">
      <li id="HeaderAboutLink" class="nav-item btn">
        <router-link to="/home" class="nav-link">Über uns </router-link>
      </li>
      <li id="HeaderSkillsLink" class="nav-item btn">
        <router-link to="/technologien" class="nav-link"
          >Unsere Skills</router-link
        >
      </li>
      <li id="HeaderSkillsLink" class="nav-item btn">
        <router-link to="/partner" class="nav-link">Unsere Partner</router-link>
      </li>


     <li id="HeaderOfficeLink" class="nav-item btn">
        <a
          class="nav-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://games.lumabit.de/officetour/"
          >Office-Tour</a
        >
      </li>

      
      <li id="HeaderJobLink" class="nav-item btn">
        <router-link to="/jobs" class="nav-link">Jobs</router-link>
      </li>
      <li id="HeaderKontaktLink" class="nav-item btn">
        <router-link to="/contact" class="nav-link">Kontakt</router-link>
      </li>
    </ul>
  </div>
</template>
